<template>
  <v-app
    id="inspire"
    class="mobile-view"
  >
    <v-app-bar
      :elevation="($route.name === 'mDashboard' ? 0 : 4)"
      app
      class="my-0 px-3"
    >
      <div
        style="width: 100%"
        class="d-flex"
      >
        <div
          align="right"
          style="width: 20%"
        >
          <v-btn
            v-show="$route.name === 'mDashboard'"
            icon
            @click="drawer = true"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-menu
            </v-icon>
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="$route.name !== 'mDashboard'"
                v-bind="attrs"
                icon
                v-on="on"
                @click="$router.go(-1)"
              >
                <v-icon
                  color="primary"
                  style="font-size: 26px"
                >
                  mdi-arrow-right
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('back') }}</span>
          </v-tooltip>
        </div>
        <div
          align="center"
          style="width: 60%"
        >
          <p
            class="mb-0 mt-2 text-center"
            style="font-size: 20px"
          >
            {{ $t($route.name) }}
          </p>
        </div>
        <div
          align="left"
          style="width: 20%"
        >
          <v-btn
            v-if="$route.name === 'mDashboard'"
            icon
            @click="settingDialog = true"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-cog-outline
            </v-icon>
          </v-btn>
          <v-btn
            v-if="$route.name !== 'mDashboard'"
            icon
            @click="goTo('mDashboard')"
          >
            <v-icon
              color="primary"
              style="font-size: 26px"
            >
              mdi-home
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
    >
      <v-sheet
        class="pa-2"
        align="center"
      >
        <v-img
          height="105"
          style="border-radius: 2px"
          :src="($store.state.logo ? $store.state.logo : '@/assets/noimage.png')"
        />
      </v-sheet>
      <v-list-item>
        <v-list-item-avatar>
          <v-img
            contain
            src="@/assets/user.png"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ $store.state.fullname }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list>
        <v-list-item
          v-for="(item, i) in menuItems"
          :key="i"
          link
          @click="goTo(item.name)"
        >
          <v-list-item-icon>
            <v-icon color="primary">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="logout"
        >
          <v-list-item-icon>
            <v-icon color="pink">
              mdi-logout
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- Sizes your content based upon application components -->
    <v-main>
      <keep-alive>
        <router-view />
      </keep-alive>
    </v-main>
    <v-dialog
      v-model="settingDialog"
      width="95%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="settingDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('setting') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-switch
              v-model="connectToP3POS"
              :label="$t('connectToP3POS')"
            ></v-switch>
          </v-col>
          <v-col
            v-show="connectToP3POS"
            cols="12"
            md="4"
          >
            <m-autocomplete
              v-model="connectedBankToP3"
              :title="$t('connectedBankToP3')"
              type="bankCash"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-switch
              v-model="sellInvoiceWithoutCustomer"
              :label="$t('sellInvoiceWithoutCustomer')"
            ></v-switch>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <m-autocomplete
              v-model="defaultCustomer"
              :title="$t('defaultCustomer')"
              type="person"
              :filter="true"
              :offline="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="settingDialog = false"
              >
                {{ $t('close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import General from './../../Mixins/general'
  export default {
    name: 'MobileIndex',
    components: {
    },
    mixins: [General],
    props: [],
    data: () => ({
      settingDialog: false,
      connectToP3POS: null,
      sellInvoiceWithoutCustomer: null,
      connectedBankToP3: null,
      defaultCustomer: null,
      drawer: false,
      tab: 0,
      menuItems: [],
    }),
    computed: {
    },
    watch: {
      tab (val) {
        this.$store.commit('SET_MOBILEAPPTAB', val)
      },
      defaultCustomer (val) {
        localStorage.setItem('defaultCustomer', JSON.stringify(val))
        this.$store.commit('SET_DEFAULTCUSTOMER', val)
      },
      sellInvoiceWithoutCustomer (val) {
        localStorage.setItem('sellInvoiceWithoutCustomer', val)
        this.$store.commit('SET_SELLINVOICEWITHOUTCUSTOMER', val)
      },
      connectToP3POS (val) {
        localStorage.setItem('connectToP3POS', (val ? 'active' : null))
      },
      connectedBankToP3 (val) {
        localStorage.setItem('connectedBankToP3', JSON.stringify(val))
      },
    },
    beforeMount () {
      this.DB = new window.JsStore.Connection()
      this.defaultCustomer = JSON.parse(localStorage.getItem('defaultCustomer'))
      this.sellInvoiceWithoutCustomer = localStorage.getItem('sellInvoiceWithoutCustomer')
      this.connectToP3POS = (localStorage.getItem('connectToP3POS') === 'active' ? 'active' : false)
      this.connectedBankToP3 = (localStorage.getItem('connectedBankToP3') ? JSON.parse(localStorage.getItem('connectedBankToP3')) : null)
      this.menuItems = [
        { name: 'mSell', title: 'mSell', image: '/img/button/mSell.jpg', icon: 'mdi-cart-plus', color: 'green' },
        { name: 'mReturnSell', title: 'mReturnSell', image: '/img/button/returnSell.jpg', icon: 'mdi-cart-minus', color: 'pink' },
        { name: 'mSellList', title: 'sellList', image: '/img/button/sellList.jpg', icon: 'mdi-playlist-plus', color: 'green' },
        { name: 'mReturnSellList', title: 'mReturnSellList', image: '/img/button/returnSellList.jpg', icon: 'mdi-playlist-minus', color: 'pink' },
      ]
    },
    mounted () {
    },
    methods: {
      logout () {
        this.$router.push({ name: 'mlogout' })
      },
    },
  }
</script>

<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.mobile-view
  .v-text-field--outlined .v-label
    top: 12px
  .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer
    margin-top: 1px
  .v-card .v-divider
    border-color: #c2c2c2
</style>

<style scoped>
/*.v-text-field--outlined .v-label {*/
/*  top:0px; !important;*/
/*}*/
</style>
